module.exports = __webpack_public_path__ + "img/left_align.e81e6c9d.svg";